<template>
  <div :class="!this.$store.getters.iframeColidee ? 'bloc p-1' : 'p-1'">
    <div class="field">
      <label class="label">{{ $t("meeting.etat") }}</label>
      <div class="hr-grey" />
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.meeting.isLoading }"
      >
        <label class="radio">
          <div
            :style="
              isChecked_STATE
                ? 'background-color:green; padding:10px;color:white'
                : 'padding:10px;'
            "
          >
            <input
              type="radio"
              value="1"
              name="STATE"
              v-bind:checked="isChecked_STATE"
              @click="onFormChange"
              v-bind="{ disabled: this.$store.state.meeting.isLoading }"
            />
            {{ $t("meeting.etat_ouvert") }}
          </div>
        </label>
        <label class="radio">
          <div
            :style="
              !isChecked_STATE
                ? isLoading
                  ? 'background-color:none; padding:10px;color:#000'
                  : 'background-color:red; padding:10px;color:#fff'
                : 'padding:10px;'
            "
          >
            <input
              type="radio"
              value="0"
              name="STATE"
              v-bind:checked="!isChecked_STATE"
              @click="onFormChange"
              v-bind="{ disabled: this.$store.state.meeting.isLoading }"
            />
            {{ $t("meeting.etat_ferme") }}
          </div>
        </label>
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("meeting.name") }}*</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.meeting.isLoading }"
      >
        <input
          :value="meeting_name"
          name="NAME"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('meeting.name')"
          v-bind="{ disabled: this.$store.state.meeting.isLoading }"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("meeting.client") }}</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.meeting.isLoading }"
      >
        <input
          :value="meeting_client"
          name="CLIENT"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('meeting.client')"
          v-bind="{ disabled: this.$store.state.meeting.isLoading }"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("meeting.evenement") }}</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.meeting.isLoading }"
      >
        <input
          :value="meeting_evenement"
          name="EVENEMENT"
          @input="onFormChange"
          class="input"
          type="text"
          :placeholder="$t('meeting.evenement')"
          v-bind="{ disabled: this.$store.state.meeting.isLoading }"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("meeting.type") }}</label>
      <div
        class="input"
        v-bind:class="{ 'is-loading': this.$store.state.meeting.isLoading }"
      >
        <label class="radio">
          <input
            type="radio"
            value="moderee"
            name="TYPE"
            v-bind:checked="isChecked_TYPE"
            @click="onFormChange"
            v-bind="{ disabled: this.$store.state.meeting.isLoading }"
          />
          {{ $t("meeting.type_moderee") }}
        </label>
        <label class="radio">
          <input
            type="radio"
            value="libre"
            name="TYPE"
            v-bind:checked="!isChecked_TYPE"
            @click="onFormChange"
            v-bind="{ disabled: this.$store.state.meeting.isLoading }"
          />
          {{ $t("meeting.type_libre") }}
        </label>
      </div>
    </div>

    <!-- Champ Open et close -->
    <div style="margin-bottom:10px;">
      <label class="label">{{ $t("meeting.openAt") }}</label>
      <div
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.meeting.isLoading }"
      >
        <b-datepicker
          :max-date="modelCloseAt"
          :locale="$store.state.langage.langue"
          :mobile-modal="false"
          v-model="modelOpenAt"
          :placeholder="$t('meeting.openAt')"
          trap-focus
          editable
          :first-day-of-week="1"
        ></b-datepicker>
      </div>
      <label style="margin-top:10px;" class="label">{{
        $t("meeting.closeAt")
      }}</label>
      <b-datepicker
        :min-date="modelOpenAt"
        :locale="$store.state.langage.langue"
        :mobile-modal="false"
        v-model="modelCloseAt"
        :placeholder="$t('meeting.closeAt')"
        expanded
        editable
        :first-day-of-week="1"
      ></b-datepicker>
      <div
        v-if="!isLoading && $store.getters.open_at < new Date()"
        style="margin-top:5px;"
      >
        <b-switch
          style="vertical-align:middle;"
          v-model="closeMeeting"
          type="is-warning"
        /><span style="margin-left:-10px;font-size:12px;">{{
          $t("meeting.close")
        }}</span>
      </div>
    </div>

    <div class="field">
      <label class="label">{{ $t("meeting.background") }}</label>
      <div
        class="input"
        style="display:flex"
        v-if="!this.$store.state.meeting.has_background && !this.file"
      >
        <b-upload
          style="margin-left:-8px;"
          accept="image/png, image/gif, image/jpeg, video/mp4"
          v-model="file"
          @input="checkFileSize()"
        >
          <p class="file-label">
            <img
              style="margin-left:5px;margin-right:10px;width:18px; height:18px;"
              src="~@/assets/img/icons/add_photo.png"
              alt="add-photo"
            /><span>{{ $t("meeting.file") }}</span>
          </p>
        </b-upload>
      </div>
      <div
        style="font-size:12px;"
        v-if="this.$store.state.meeting.has_background || this.file"
      >
        <b-icon pack="fas" icon="check-square" size="is-small"></b-icon>
        {{ $t("meeting.file_ok") }}
        <span
          style="margin-left:55px;font-size:16px;cursor:pointer;"
          @click="removeFile()"
        >
          <b-tooltip
            position="is-left"
            :label="this.$t('meeting.deleted-image')"
          >
            <b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon>
          </b-tooltip>
        </span>
      </div>

      <img
        style="width:250px"
        v-if="this.$store.state.meeting.has_background"
        :src="this.url_textit + this.$store.state.meeting.has_background"
      />
      <div style="width:250px;" id="preview">
        <img v-if="url" :src="url" />
      </div>
    </div>

    <div class="field">
      <textarea
        class="textarea petittextarea is-invisible"
        :value="meeting_hashtags"
        name="HASHTAGS"
        placeholder="Ajouter un hashtag"
        rows="1"
      ></textarea>

      <label v-if="!this.$store.getters.iframeColidee" class="label"
        >{{ $t("meeting.hashtags") }}
        <div class="is-size-7 is-italic">
          {{ $t("meeting.hashtags_howto") }}
        </div>
      </label>
      <div
        v-if="!this.$store.getters.iframeColidee"
        class="control"
        v-bind:class="{ 'is-loading': this.$store.state.meeting.isLoading }"
      >
        <b-taginput
          style="border-radius:0px;"
          class="tag-input"
          v-model="meeting_hashtags_tag"
          :before-adding="beforeAddingHashtag"
          ellipsis
          icon="label"
          :placeholder="$t('meeting.ajouter_hashtag')"
          @add="addHashtag"
          @remove="removeHashtag"
          v-bind="{ disabled: this.$store.state.meeting.isLoading }"
        >
        </b-taginput>
      </div>
    </div>
    <div
      style="margin-top:5px;"
      v-if="
        $store.state.meeting.fields.questions_count && stateOnlinePreview == '1' &&
          isChecked_STATE
      "
    >
      <b-message type="is-danger" style="margin-bottom:10px;font-size:12px;">{{
        $t("meeting.previewAndVotes.text")
      }}</b-message>
    </div>
    <div>
      <div style="right:0px;">
        <div class="has-text-right">
          <div>
            <button
              class="button is-primary"
              @click="SubmitForm()"
              v-bind="{ disabled: this.$store.state.meeting.isLoading }"
            >
              {{ $t("button.sauvegarder") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Parameters",
  data() {
    return {
      file: null,
      url_textit: process.env.URL_MEDIA,
      query: "",
      pending: false,
      erreur_email: false,
      errors: [],
      data: [],
      tags: [],
      filteredTags: [],
      shares: [],
      selectedCountryFr: true,
      selectedCountryEn: false,
      selectedCountryEs: false,
      selectedCountryDe: false,
      showWarningTranslation: false,
      url: "",
      stateOnlinePreview: '0'
    };
  },
  watch: {
    meeting_id() {
      this.getShares(this.meeting_id);
    }
  },
  computed: {
    ...mapGetters([
      "isLoading",
      "meetings",
      "meeting_name",
      "meeting_id",
      "meeting_evenement",
      "meeting_client",
      "meeting_state",
      "meeting_hashtags"
    ]),
    modelOpenAt: {
      get: function() {
        return this.$store.getters.open_at !== null
          ? this.$store.getters.open_at
          : null;
      },
      set: function(newValue) {
        this.$store.commit("SET_OPEN_AT", newValue);
      }
    },
    modelCloseAt: {
      get: function() {
        return this.$store.getters.close_at !== null
          ? this.$store.getters.close_at
          : null;
      },
      set: function(newValue) {
        // si on met une date à la main alors on enleve le toggle cloture de la reunion
        this.$store.commit("SET_CLOSE_MEETING", 0);
        this.$store.commit("SET_CLOSE_AT", newValue);
      }
    },
    closeMeeting: {
      get: function() {
        if (this.$store.getters.getCloseMeeting === 1) return true;
        else return false;
      },
      set: function(newValue) {
        if (newValue === true) {
          this.$store.commit("SET_CLOSE_MEETING", 1);
          this.$store.commit("SET_CLOSE_AT", new Date());
        }
        else {
          this.$store.commit("SET_CLOSE_MEETING",0);
          this.$store.commit("SET_CLOSE_AT", null);
        }
      }
    },
    meeting_hashtags_tag: {
      get: function() {
        var hashtags = [];
        var hashtags = this.$store.state.meeting.fields.hashtags.split(";");
        hashtags.pop();
        return hashtags;
      },
      set: function(newValue) {}
    },
    showResultsClient: {
      get: function() {
        if (this.$store.getters.showResultsClient === 1) return true;
        else return false;
      },
      set: function(newValue) {
        if (newValue === true) {
          this.$store.commit("SHOW_RESULTS_CLIENT", 1);
        } else {
          this.$store.commit("SHOW_RESULTS_CLIENT", 0);
        }
      }
    },
    isChecked_STATE() {
      if (this.$store.state.meeting.fields.state == 1) {
        return true;
      } else {
        return false;
      }
    },
    isChecked_TYPE() {
      if (this.$store.state.meeting.fields.type == "moderee") {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    meetings() {
      this.loading = false;
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        cardList: true,
        parameters: false
      });
    }
  },
  created() {
    this.$store.commit("RAZ_RESULTS_COUNT");

  },
  updated() {
    if (!this.isChecked_STATE && !this.$store.state.meeting.fields.state) this.stateOnlinePreview = '1';
    let message = {
      task: "updateHeight",
      height: document.body.scrollHeight
    };
    window.top.postMessage(message, "*");
  },
  methods: {
    checkFileSize() {
      if (this.file && this.file.size > 6000000) {
        this.file = null;
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.fichier_trop_lourd")
        });
      }
      this.url = URL.createObjectURL(this.file);
    },
    removeFile() {
      this.url = "";
      this.$store.commit(`UPDATE_HAS_BACKGROUND`, null);
      this.file = null;
    },
    addHashtag(tag) {
      this.$store.commit(
        `UPDATE_MEETING_HASHTAGS`,
        this.$store.state.meeting.fields.hashtags + tag + ";"
      );
    },
    removeHashtag(tag) {
      var recherche = tag + ";";
      var resultat = this.$store.state.meeting.fields.hashtags.replace(
        recherche,
        ""
      );
      this.$store.state.meeting.fields.hashtags = resultat;
    },
    beforeAddingHashtag(tag) {
      // var regex = /(?:\s|^)#[A-Za-z0-9\-\.\_]+(?:\s|$)/g;
      var regex = /^#[A-Za-z0-9\-\.\_]+$/g;
      if (tag.match(regex)) {
        return true;
      } else {
        this.toast.open({
          type: "is-danger",
          message: "Hashtag incorrect"
        });
        return false;
      }
    },
    SubmitForm(evt) {
      this.loading = true;
      if (this.$store.state.meeting.isEditing) {
        this.$store.dispatch("update_meeting", this.file);
      } else {
        this.$store.dispatch("create_new_meeting", this.file);
      }
      this.file = null;
    },
    onFormChange(evt) {
      this.$store.commit(`UPDATE_MEETING_${evt.target.name}`, evt.target.value);
    }
  }
};
</script>
<style scoped>
.input {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.input::placeholder {
  color: grey;
}
label {
  font-size: 12px;
}
.flag {
  opacity: 0.2;
  cursor: pointer;
}
.selected-flag {
  opacity: 1;
  cursor: pointer;
}
.button {
  border-radius: 0px;
  font-size: 12px;
  color: white;
}
.column {
  padding-bottom: 0px !important;
}
.textarea {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.textarea::placeholder {
  color: grey;
}
.p-1 {
  padding: 10px;
}
.hr-grey {
  height: 1px;
  width: 100%;
  background: grey;
}
.texte_petit {
  font-size: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/adminPage/Parameters.vue